import styled from "styled-components";

export const StyledCloseBtn = styled.button`
	border: none;
	background: transparent;
	outline: none;
	cursor: pointer;
	width: 16px;
	height: 16px;

	img {
		width: ${({ small }) => (small ? "8px" : "auto")};
	}
`;
